import { motion } from "framer-motion";
import { Briefcase } from "lucide-react";
import { CAREERS } from "@/data/content";

export default function CareerPaths() {
  return (
    <section id="careers" data-testid="careers-section" className="section bg-[#F8F9FA]">
      <div className="container-x">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#B31942]/20 bg-[#B31942]/5 px-3 py-1 text-[12px] font-semibold text-[#B31942]">
            Career Paths
          </div>
          <h2 className="mt-4 font-display font-extrabold text-4xl md:text-5xl tracking-tight text-slate-900">
            Fifteen high-demand <span className="text-[#0A3161]">career roles</span>.
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Our alumni step into these titles across product companies, service firms and startups.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
          {CAREERS.map((c, i) => (
            <motion.div
              key={c}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 5) * 0.04 }}
              className="rounded-xl bg-white border border-black/5 p-4 flex items-center gap-3 hover:border-[#0A3161]/25 transition-colors soft-shadow"
              data-testid={`career-${c.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="h-9 w-9 rounded-lg bg-[#0A3161]/10 text-[#0A3161] inline-flex items-center justify-center">
                <Briefcase className="h-4 w-4" />
              </span>
              <span className="text-sm font-semibold text-slate-800">{c}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
